var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpierror(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1028_62",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 61
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.593506,
    width: 60,
    height: 60,
    fill: "#FF4B51"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1028_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 43.0935C30.7083 43.0935 31.3021 42.8539 31.7813 42.3748C32.2604 41.8956 32.5 41.3018 32.5 40.5935C32.5 39.8852 32.2604 39.2914 31.7813 38.8123C31.3021 38.3331 30.7083 38.0935 30 38.0935C29.2917 38.0935 28.6979 38.3331 28.2188 38.8123C27.7396 39.2914 27.5 39.8852 27.5 40.5935C27.5 41.3018 27.7396 41.8956 28.2188 42.3748C28.6979 42.8539 29.2917 43.0935 30 43.0935ZM27.5 33.0935H32.5V18.0935H27.5V33.0935ZM30 55.5935C26.5417 55.5935 23.2917 54.9373 20.25 53.6248C17.2083 52.3123 14.5625 50.531 12.3125 48.281C10.0625 46.031 8.28125 43.3852 6.96875 40.3435C5.65625 37.3018 5 34.0518 5 30.5935C5 27.1352 5.65625 23.8852 6.96875 20.8435C8.28125 17.8018 10.0625 15.156 12.3125 12.906C14.5625 10.656 17.2083 8.87476 20.25 7.56226C23.2917 6.24976 26.5417 5.59351 30 5.59351C33.4583 5.59351 36.7083 6.24976 39.75 7.56226C42.7917 8.87476 45.4375 10.656 47.6875 12.906C49.9375 15.156 51.7188 17.8018 53.0312 20.8435C54.3438 23.8852 55 27.1352 55 30.5935C55 34.0518 54.3438 37.3018 53.0312 40.3435C51.7188 43.3852 49.9375 46.031 47.6875 48.281C45.4375 50.531 42.7917 52.3123 39.75 53.6248C36.7083 54.9373 33.4583 55.5935 30 55.5935Z",
    fill: "#FF4B51"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpierror);
export default __webpack_public_path__ + "static/media/upierror.43a600d644fb396879597455c60924c9.svg";
export { ForwardRef as ReactComponent };